import React, { useContext } from 'react';
import {
  Footer,
  MainHeader,
  GamesList,
  ProductsList,
  InfoBanner,
} from '@homeplay/components';
import {
  SiteContext,
  selectProducts,
  selectTopGames,
  selectHhSchedules,
} from '@homeplay/app';
import classes from './MainPage.module.scss';
import bannerImg from '../../assets/images/banner.png';
import bannerMobileImg from '../../assets/images/banner-mobile.png';
import { useSelector } from 'react-redux';

const MainPage = () => {
  const { isDesktop } = useContext(SiteContext);
  const products = useSelector(selectProducts);
  const topGames = useSelector(selectTopGames);
  const { nearestHh } = useSelector(selectHhSchedules);

  return (
    <React.Fragment>
      <MainHeader />
      <main className={classes.MainMenu}>
        <div className={classes.ContentWrap}>
          {nearestHh && <InfoBanner texts={nearestHh.texts} />}
          <div className={classes.Banner}>
            {isDesktop ? (
              <img src={bannerImg} alt="" width="1920" height="308" />
            ) : (
              <img src={bannerMobileImg} alt="" width="1330" height="308" />
            )}
          </div>
          {products && <ProductsList products={products} />}
        </div>
        <div className="container games-wrap">
          <h4>Enjoy Playing Games</h4>
          <svg
            className={classes.Divider}
            width="246"
            height="15"
            viewBox="0 0 246 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="116"
              y="7.07324"
              width="10.003"
              height="10.0025"
              transform="rotate(-45 116 7.07324)"
              fill="#6d9503"
            />
            <path
              d="M0 7.2L97.8676 4L110 7.2L97.8676 10L0 7.2Z"
              fill="#6d9503"
            />
            <path
              d="M246 6.8L148.132 10L136 6.8L148.132 4L246 6.8Z"
              fill="#6d9503"
            />
          </svg>
          <h4>Most Popular</h4>
          {topGames && <GamesList games={topGames} />}
        </div>
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default MainPage;
